import { render, staticRenderFns } from "./CampaignSetupsListRowUsage.vue?vue&type=template&id=f006db46"
import script from "./CampaignSetupsListRowUsage.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsListRowUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports